import React, { useState } from "react";
import { descargarArchivo, ApiError } from "../api";

const ETIQUETA_FORMATO: Record<string, string> = { pdf: "PDF", xlsx: "Excel", docx: "Word" };

// Control reutilizable de descarga de reportes: selector de formato + botón,
// contra cualquier endpoint "<ruta>/exportar" del motor genérico de
// exportación (app/exportes_utils.py) — usado en Contabilidad desde la Fase
// 7 y ahora también en el apartado consolidado de Reportes (ver
// pages/Reportes.tsx y README.md, Bloque 8).
export function DescargaReporte({ endpoint, params, nombreBase, formatos = ["pdf", "xlsx", "docx"], label = "Descargar" }: {
  endpoint: string; params?: Record<string, string | number | undefined>; nombreBase: string; formatos?: string[]; label?: string;
}) {
  const [formato, setFormato] = useState(formatos[0]);
  const [descargando, setDescargando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const descargar = async () => {
    setDescargando(true);
    setError(null);
    try {
      const entradas = Object.entries({ formato, ...params }).filter(([, v]) => v !== undefined && v !== "") as [string, string | number][];
      const qs = new URLSearchParams(entradas.map(([k, v]) => [k, String(v)]));
      await descargarArchivo(`${endpoint}?${qs.toString()}`, `${nombreBase}.${formato}`);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "No se pudo generar el reporte.");
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <select
        className="rounded-lg border border-borderc bg-white px-2 py-2 text-xs text-slate-700 focus:outline-none focus:ring-4 focus:ring-accent/15 focus:border-accent"
        value={formato} onChange={(e) => setFormato(e.target.value)}
      >
        {formatos.map((f) => <option key={f} value={f}>{ETIQUETA_FORMATO[f] || f}</option>)}
      </select>
      <button className="btn-ghost" disabled={descargando} onClick={descargar}>{descargando ? "Generando..." : label}</button>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
